import React from 'react';

const Faq = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38.011" height="38.011" viewBox="0 0 38.011 38.011"><path d="M23.935,0A14.069,14.069,0,0,0,11.972,6.656,15.936,15.936,0,0,0,1.585,29.019v7.407H8.991A15.938,15.938,0,0,0,31.352,26.043,14.078,14.078,0,0,0,23.935,0ZM15.922,35.783a13.549,13.549,0,0,1-6.168-1.465l-.237-.12h-5.7V28.493l-.12-.237a13.551,13.551,0,0,1-1.465-6.169,13.695,13.695,0,1,1,13.695,13.7Zm15.9-12.866q.021-.413.021-.83A15.922,15.922,0,0,0,15.922,6.165q-.414,0-.825.021A11.848,11.848,0,1,1,31.823,22.917Z" transform="translate(0)" fill="#4d4332"/><text transform="translate(15.479 29.011)" fill="#4d4332" font-size="24" font-family="CourierNewPS-BoldMT, Courier New" font-weight="700" letter-spacing="0.02em"><tspan x="-7.201" y="0">?</tspan></text></svg>    );
}


export default Faq;
